module.exports = __webpack_public_path__ + "img/chatgenie-logo-beta.9ef6332e.svg";